// @flow
import React from 'react';
import stylesheet from './counter.scss';
import classnames from 'classnames';

type Props = {
  maxLength: number,
  currentLength: number,
  errorMessage: string,
};

const Counter = ({ maxLength, currentLength, errorMessage }: Props) => {
  const isInvalid = currentLength > maxLength;
  return (
    <div
      className={classnames(stylesheet.counter, {
        [stylesheet['counter--error']]: isInvalid,
      })}
    >
      <div>{isInvalid && <span>{errorMessage}</span>}</div>
      <div>
        {currentLength}/{maxLength}
      </div>
    </div>
  );
};

export default Counter;
